export default __webpack_public_path__ + "static/fonts/PFBagueSansPro-Thin-4QN26U7E.woff2!static";